// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  schemId: __t.u64().primaryKey().name("schem_id"),
  owner: __t.identity(),
  schematicKey: __t.string().name("schematic_key"),
  source: __t.string(),
  learnedAt: __t.timestamp().name("learned_at"),
});
